<div class="risk-tooltip-card" [class.compact]="compact">
  @if (!compact) {
  <div class="tooltip-header">
    <div class="currency-header-card">
      <div class="currency-icon-container">
        @if (icons.length > 1) {
          @for (icon of icons; track $index; let i = $index) {
            <img
              [src]="icon"
              (error)="useFallbackIcon($event)"
              alt=""
              class="icon"
              [ngClass]="{
                'main-icon': i === 0,
                'secondary-icon': i === 1,
              }"
            />
          }
        } @else {
          @for (icon of icons; track $index) {
            <img [src]="icon" (error)="useFallbackIcon($event)" alt="" class="icon single-icon" />
          }
        }

        <span class="currency-icon" [ngClass]="iconClass"></span>
      </div>

      <div class="currency-details">
        <div class="currency-name">
          {{ currency.currencySymbol }}
        </div>

        <div class="currency-balance-wrapper">
          <div class="currency-balance">
            {{ formatAmount(totalBalance) }}
          </div>

          <div class="currency-fiat-balance">
            @if (hasBaseCurrencyTotal) {
              ≈ {{ formatBaseAmount(totalBaseBalance) }}
            } @else {
              ≈ $ —
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="tooltip-divider"></div>
  }

  <div class="risk-title">Risk Distribution</div>

  @if (riskDistribution.length) {
    <div class="risk-bar">
      @for (item of riskDistribution; track item.riskLevel) {
        <div
          class="risk-segment"
          [style.width.%]="item.percentage"
          [style.background]="getRiskColor(item.riskLevel)"
        ></div>
      }
    </div>

    <div class="risk-list">
      @for (item of riskDistribution; track item.riskLevel) {
        <div class="risk-row">
          <div class="risk-label">
            <span class="risk-dot" [style.background]="getRiskColor(item.riskLevel)"></span>

            <span> {{ getRiskLabel(item.riskLevel) }} Risk </span>
          </div>

          <div class="risk-percentage">{{ item.percentage }}%</div>

          <div class="risk-balance">
            {{ formatAmount(item.balance) }}
            <span class="risk-balance-currency">{{ currency.currencySymbol }}</span>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="risk-empty">No risk distribution available</div>
  }
</div>
